<template>
  <v-container>
    <v-card outlined>
      <v-card-title>Crea {{ model.verboseName.toLowerCase() }}</v-card-title>
      <v-card-text>
        <slot name="form" v-bind="{ error, submit }"></slot>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapState } from "vuex"

export default {
  props: {
    model: {
      type: Object,
      required: true,
    },
  },
  computed: mapState({
    error(state) {
      if (state[this.model.appName].error[this.model.propName]) {
        return state[this.model.appName].error[this.model.propName].response
          .data
      }
      return {}
    },
  }),
  methods: {
    async submit(event) {
      const item = event
      try {
        await this.$store.dispatch(`create${this.model.modelName}`, {
          data: item,
        })
        this.$store.commit("core/setSnack", {
          level: "success",
          msg: "Creato con successo.",
        })
        this.$router.push({ name: `${this.model.modelNamePlural}` })
      } catch (err) {
        if (err.response.status >= 500) {
          alert(err)
        }
        this.$store.commit("core/setSnack", {
          level: "error",
          msg: "Creazione non riuscita. Controlla gli errori e riprova.",
        })
      }
    },
  },
}
</script>
